export default __webpack_public_path__ + "static/media/c006-1.20ab4bce.jpg";